/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/okb.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const okbPage: ICoinPageData = {
  title: 'coin_732',
  description: 'coin_733',
  // description: 'coin_734',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'OKB (OKB)' }) }}
    />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_735',
        answer: 'coin_736',
      },
      {
        title: 'coin_737',
        answer: 'coin_738',
      },
      {
        title: 'coin_739',
        answer: 'coin_740',
      },
      {
        title: 'coin_741',
        answer: 'coin_742',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('OKB (OKB)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_743',
        text: ['coin_745'],
      },
      {
        title: 'coin_744',
        text: ['coin_746'],
      },
    ],
    blogCards: [blogCards.borrowLikePro, blogCards.cryptoCrash],
  },
}
